import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      gap: 24
    }}>
      <h1 style={{ fontSize: 80, fontWeight: 'bold', margin: 0 }}>404</h1>
      <p style={{ fontSize: 20, margin: 0, color: '#666' }}>Page not found</p>
      <Link to="/"
        style={{
          padding: '12px 24px',
          background: '#3b82f6',
          color: 'white',
          borderRadius: 4,
          textDecoration: 'none'
        }}
      >
        Back to Home
      </Link>
    </div>
  );
}
